module.exports = __webpack_public_path__ + "img/wel_title.9c89b3d4.png";